const sliderr = document.querySelector('.review-container');

if (sliderr){

let isDown = false;
let startX;
let scrollLeft;

let velocity = 0;
let lastX = 0;
let momentumID;

sliderr.addEventListener('mousedown', (e) => {
  e.preventDefault();
  isDown = true;
  startX = e.pageX;
  scrollLeft = sliderr.scrollLeft;
  lastX = startX;
  velocity = 0;

  cancelAnimationFrame(momentumID);
  sliderr.style.cursor = 'grabbing';
});

sliderr.addEventListener('mousemove', (e) => {
  if (!isDown) return;

  const x = e.pageX;
  const walk = x - startX;

  sliderr.scrollLeft = scrollLeft - walk;

  velocity = x - lastX;   // speed capture
  lastX = x;
});

function momentumScroll() {
  sliderr.scrollLeft -= velocity;
  velocity *= 0.95; // friction (lower = more smooth, higher = more distance)

  if (Math.abs(velocity) > 0.5) {
    momentumID = requestAnimationFrame(momentumScroll);
  }
}

sliderr.addEventListener('mouseup', () => {
  isDown = false;
  sliderr.style.cursor = 'grab';
  momentumScroll();
});

sliderr.addEventListener('mouseleave', () => {
  if (!isDown) return;
  isDown = false;
  sliderr.style.cursor = 'grab';
  momentumScroll();
});

}